/**
 * Routing Result Type
 *
 */
export var RoutingResultType;
(function (RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})(RoutingResultType || (RoutingResultType = {}));
//# sourceMappingURL=routing.js.map